//meroxio lazy load script
    var isReplaced = false;
    function MeroxIO_Function(){
      if(!isReplaced){
        window.yett.unblock();
        console.log("apps lazyloaded successfully");
        isReplaced=true;
      }
    }
    document.addEventListener("click", MeroxIO_Function);
    document.addEventListener("scroll", MeroxIO_Function);
    document.addEventListener("touchstart", MeroxIO_Function);
    document.addEventListener("mousemove", MeroxIO_Function);
    document.addEventListener("DOMContentLoaded", function() {
      var lazyImages = [].slice.call(document.querySelectorAll("img.merox-lazy"));
      if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              let lazyImage = entry.target;
              lazyImage.src = lazyImage.dataset.src;
              lazyImage.classList.remove("merox-lazy");
              lazyImageObserver.unobserve(lazyImage);
            }
          });
        });
        lazyImages.forEach(function(lazyImage) {
          lazyImageObserver.observe(lazyImage);
        });
      }
    });

//searchspring unwanted text settings
document.addEventListener('DOMContentLoaded', function() {
      var rteElements = document.querySelectorAll('.collection__description .rte');
      rteElements.forEach(function(element) {
          var unwantedText = 'The Search Results page for Searchspring content. The URL handle is collections/shop.';
          if (element.textContent.includes(unwantedText)) {
              element.innerHTML = element.innerHTML.replace(unwantedText, '');
          }
      });
  });